module.exports = __webpack_public_path__ + "img/arh_6.8a471887.png";